<template>
    <el-dialog :show-close="false" :custom-class="'user-dialog'" :visible="dialogvisible" width="70%"
               @close="$emit('update:dialogvisible', false); visiblePassword=false">
        <vue-scroll class="page-calendar margin-top-20">
            <FullCalendar
                    id='calendar'
                    ref="fullCalendar"
                    defaultView="listMonth"
                    :events="events"
                    :locale="locale"
                    :eventTimeFormat="eventTimeFormats"
                    :plugins="calendarPlugins"
                    :firstDay="options.firstDay"
                    :customButtons="options.customButtons"
                    :header="options.header"
                    :height="options.height"
                    :allDaySlot="options.allDaySlot"
                    :slotEventOverlap="options.slotEventOverlap"
                    :selectable="options.selectable"
                    :navLinks="options.navLinks"
                    :editable="options.editable"
                    :eventLimit="options.eventLimit"
                    @dateClick="dayClick"
                    @eventClick="eventClick"
                    class="calendar-wrap card-base card-shadow--medium"
            />
            <randevu-ekle v-if="dialogVisibleRandevu" :dialogvisible.sync="dialogVisibleRandevu" :randevuId="randevuId"
                          :hastaId="hastaId" :hekimId="hekimId" :hekimVisible="hekimVisible" :hastadata="hastadata"></randevu-ekle>
        </vue-scroll>
    </el-dialog>
</template>

<script>
    import cerrahiService from '../WSProvider/CerrahiService'
    import randevuService from '../WSProvider/RandevuService'
    import moment from 'moment-timezone'
    import FullCalendar from '@fullcalendar/vue'
    import dayGridPlugin from '@fullcalendar/daygrid'
    import timeGridPlugin from '@fullcalendar/timegrid';
    import listPlugin from '@fullcalendar/list';
    import interactionPlugin from '@fullcalendar/interaction';
    import {Calendar} from '@fullcalendar/core';
    import trLocale from '@fullcalendar/core/locales/tr';
    import RandevuEkle from '@/components/RandevuEkle'
    import EventBus from '@/components/event-bus'
    import notification from '../notification'
    import functions from '../functions'


    export default {
        name: 'ModalDash',
        // watch: {
        //     hekimVisible: function (val) {
        //         console.log(val)
        //     }
        // },
        props: ['userdata','dialogvisible'],
        data() {
            return {
                hastadata : this.userdata,
                hastaId: '',
                hekimId: '',
                randevuId : '',
                uygulamaTarihId : '',
                dialogVisibleRandevu: false,
                hekimVisible : false,

                calendarPlugins: [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
                eventTimeFormats: {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                },
                events: [],
                locale: trLocale,

                options: {
                    customButtons: {
                        addEvent2: {
                            text: '✚',
                            click: this.deneme
                        },
                        addEvent: {
                            text: '📅',
                            click: this.addEventDialog
                        }
                    },
                    header: {
                        left: 'prev,next today',
                        center: 'title',
                        right: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth addEvent addEvent2'
                    },
                    height: "auto",
                    firstDay: 1,
                    allDaySlot: true,
                    slotEventOverlap: true,
                    selectable: true,
                    selectHelper: true,
                    timeFormat: 'HH:mm',
                    navLinks: true, // can click day/week names to navigate views
                    editable: false,
                    eventLimit: true, // allow "more" link when too many events
                }
            }
        },
        mounted() {
            this.getRandevuListesi();
            this.getCerrahiListesi();
            let self = this;
            EventBus.$on('randevuList', function (bool) {
                if (bool) {
                    self.events = [];
                    self.getRandevuListesi();
                    self.getCerrahiListesi();
                }
            });
        },
        methods: {
            getCerrahiListesi() {
                let self = this;
                cerrahiService.hastaCerrahiList(this.userdata.hastaId).then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            var max = 0xffffff;
                            var renk = '#' + Math.round(Math.random() * max).toString(16);
                            self.events.push({
                                title: e.hasta+" ( Cerrahi Uygulama)",
                                id: e.hastaId,
                                hekimId: e.hekimId,
                                uygulamaTarihId: e.uygulamaTarihId,
                                start: e.tarih.split(' ')[0] + "T" + e.tarih.split(' ')[1],
                                color: '#00cbc0'
                            })
                        });
                    }
                });
            },
            getRandevuListesi() {
                let self = this;
                randevuService.randevuHastaList(this.userdata.hastaId).then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            var max = 0xffffff;
                            var renk = '#' + Math.round(Math.random() * max).toString(16);
                            self.events.push({
                                title: e.hasta + " ( " + e.randevuSayisi + ". Randevu )",
                                id: e.hastaId,
                                hekimId: e.hekimId,
                                randevuId: e.randevuId,
                                start: e.tarih.split(' ')[0] + "T" + e.tarih.split(' ')[1],
                                color: renk
                            })
                        });
                    }
                });
            },



            addEventDialog(arg) {
                this.randevuId = "";
                this.hekimVisible = false;
                this.hastaId = this.userdata.hastaId;
                this.dialogVisibleRandevu = true
            },
            dayClick(arg) {
                this.hekimVisible = false;
                this.hastaId = this.userdata.hastaId;
                this.dialogVisibleRandevu = true
            },

            deneme(){
                this.dialogvisible = false
                this.$store.commit('changeHastaKodu', this.hastadata.hastaId);
                this.$store.commit('changeHekimKodu', this.hastadata.hekimId);
                this.route('Cerrahi Tanımlama');
            },
            eventClick(arg) {
                this.randevuId = arg.event.extendedProps.randevuId;
                this.uygulamaTarihId = arg.event.extendedProps.uygulamaTarihId;
                if(this.uygulamaTarihId){
                    this.dialogvisible = false
                    this.route('Cerrahi Güncelleme',this.uygulamaTarihId);
                }else if(this.randevuId){
                    this.hekimVisible = false;
                    this.hastaId = this.userdata.hastaId;
                    var obj = this.events.find(data => data.id === this.hastaId);
                    if (obj !== undefined) {
                        this.hekimId = obj.hekimId;
                    }
                    this.dialogVisibleRandevu = true
                }

            },
            route(name, scope) {
                var tabList = this.$store.state.tabList;
                if (scope) {
                    this.$store.commit('changeUpdateKodu', scope);
                }
                var header = functions.linkTemizle(name.replace(" ", ""));
                var obj = tabList.find(data => data.title === name);
                if (obj === undefined) {
                    tabList.push({
                        title: name,
                        name: header,
                        contentName: header
                    });
                    this.$store.commit('changeTabList', tabList);
                    this.$store.commit('changeActiveTabs', header);
                } else {
                    this.$store.commit('changeActiveTabs', header);
                }
            },
        },
        components: {
            FullCalendar,
            RandevuEkle
        }
    }
</script>

<style lang="scss">
    @import '../assets/scss/_variables';
    @import '~@fullcalendar/core/main.css';
    @import '~@fullcalendar/daygrid/main.css';
    @import '~@fullcalendar/timegrid/main.css';
    @import '~@fullcalendar/list/main.css';

    /*.page-calendar {
        .calendar-wrap {
            //background: white;
        }
    }*/
</style>